/*!
 * PXG Australia – club gallery follows the chosen head (NEW file, not Dawn core).
 * When a shopper picks a model (e.g. GEN8 T / P / XP) or colour (Chrome / Black / Platinum)
 * in the club configurator, show the matching product photo.
 * Photos are matched on their alt text, written as "<Model> – <Colour> – <view>",
 * e.g. "GEN8 P – Black – heel" or "Battle Ready II Closer – Platinum – face".
 * Parts are compared whole, so "Black Jack" never counts as the colour Black.
 */
(function () {
  'use strict';
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function parts(alt) { return norm(alt).split(/\s+[–—-]\s+/); }

  function show(gallery, slide) {
    var id = slide.getAttribute('data-media-id');
    gallery.querySelectorAll('.pxg-gallery__slide').forEach(function (s) {
      s.classList.toggle('is-active', s === slide);
    });
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === id);
    });
    if (window.matchMedia('(max-width: 989px)').matches && slide.parentNode && slide.parentNode.scrollTo) {
      slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  function sync(section, force) {
    var gallery = section.querySelector('[data-pxg-gallery]');
    var cfg = section.querySelector('[data-pxg-cfg]');
    if (!gallery || !cfg) return;
    var f = cfg.querySelector('[data-set="finish"].is-on');
    var m = cfg.querySelector('[data-set="model"].is-on');
    var finish = f ? norm(f.getAttribute('data-val')) : '';
    var model = m ? norm(m.getAttribute('data-val')) : '';
    if (!finish && !model) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pxg-gallery__slide'));
    var tagged = slides.some(function (s) { return finish && parts(s.getAttribute('data-alt')).indexOf(finish) > 0; });
    var best = null, bestScore = 0;
    slides.forEach(function (s) {
      var p = parts(s.getAttribute('data-alt')), score = 0;
      if (finish && p.indexOf(finish) > 0) score += 2;   // colour is never the first part (that's the model)
      if (model && p[0] === model) score += 1;
      if (tagged && finish && score < 2) return;         // a colour is chosen and photos are tagged: colour must match
      if (p[p.length - 1] === 'beauty') score += 0.5;   // prefer the hero shot of that head
      if (score > bestScore) { bestScore = score; best = s; }
    });
    if (!best) return;
    var active = gallery.querySelector('.pxg-gallery__slide.is-active');
    if (!force && active && active !== best) {
      // keep the current photo if it already matches as well as the best one
      var ap = parts(active.getAttribute('data-alt')), as = 0;
      if (finish && ap.indexOf(finish) > 0) as += 2;
      if (model && ap[0] === model) as += 1;
      if (ap[ap.length - 1] === 'beauty') as += 0.5;
      if (as >= bestScore) return;
    }
    if (active !== best) show(gallery, best);
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-set="finish"], [data-set="model"]');
    if (!pill) return;
    var section = pill.closest('.pxg-pdp');
    if (!section) return;
    // run after the configurator has re-rendered (and after its own image switch)
    setTimeout(function () { sync(section, true); }, 80);
  }, true); // capture: the configurator re-renders its buttons on click

  function boot() {
    document.querySelectorAll('.pxg-pdp').forEach(function (section) {
      var tries = 0;
      (function wait() {
        if (section.querySelector('[data-pxg-cfg] [data-set]')) { sync(section, false); return; }
        if (++tries < 40) setTimeout(wait, 150);
      })();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
